<sh-app-access-not-configured
	*ngIf="(secondaryNavService.getIsPermissionAvailable$() | async) === false && !hasAddLicenseAccess()"
></sh-app-access-not-configured>
<ng-container *ngIf="(secondaryNavService.getIsPermissionAvailable$() | async) === true">
	<ng-container>
		<ng-container *ngIf="getSecondaryNavListItems$ | async as secondaryNavListItems">
			@if (secondaryNavListItems.length > 0) {
				<sh-secnav-layout *transloco="let t" [isCloseButtonEnabled]="false" class="sh-secondary-nav-home">
					<sh-secnav-layout-secnav>
						<span id="sh-secondary-nav-header">{{ t(routeTitle) }}</span>
						@if (showAddLicense()) {
							<prism-button
								id="sh-add-licenses-button"
								variant="bright"
								(click)="handleShowAddLicense()"
								[disabled]="getShowAddLicenses$ | async"
							>
								@if (getShowAddLicenses$ | async) {
									<prism-progress-indicator
										type="circular"
										mode="indeterminate"
										value="0"
										size="sm"
										id="sh-add-licenses-loading-icon"
										slot="icon-start"
									></prism-progress-indicator>
								} @else {
									<prism-icon
										id="sh-add-licenses-plus-icon"
										slot="icon-start"
										icon="add"
									></prism-icon>
								}
								{{ t('cloud.shure-cloud.license-management.add-licenses') }}
							</prism-button>
						}
						<mat-nav-list *ngFor="let secondaryNavListItem of getSecondaryNavListItems$ | async">
							<mat-list-item
								(click)="navigateToPath(secondaryNavListItem)"
								id="sh-secondary-nav-{{ secondaryNavListItem.id }}"
								class="sh-secondary-nav-list-item"
								[ngClass]="{
									'sh-secondary-nav-org-list-item':
										secondaryNavListItem.feature === 'organization-settings'
								}"
							>
								<div class="sh-secondary-nav-content">
									<prism-icon
										*ngIf="secondaryNavListItem.icon"
										[icon]="secondaryNavListItem.icon"
										class="sh-secondary-nav-menu-list-item-prism-icon"
										id="sh-secondary-nav-{{ secondaryNavListItem.id }}-icon"
										size="sm"
									></prism-icon>
									<span id="sh-secondary-nav-nav-menu-list-item-{{ secondaryNavListItem.id }}-span">{{
										secondaryNavListItem.listItem
									}}</span>
								</div>
							</mat-list-item>
						</mat-nav-list>
					</sh-secnav-layout-secnav>
					<sh-secnav-layout-content>
						<div id="sh-secondary-nav-content-div">
							<div id="sh-secondary-nav-right-content-div">
								<ng-container *ngIf="activeListItem$ | async as activeListItem">
									<sh-header-toolbar
										[showSidenavToggleButton]="true"
										[showBreadCrumbs]="false"
										[showFeatureButton]="!isSmallDevice() && !isLandscape()"
										[showNotifications]="true"
										(toggleSidenav)="openSidenav()"
										(signOut)="onSignOut()"
									></sh-header-toolbar>
								</ng-container>
								<sh-breadcrumbs
									*ngIf="breadCrumbs().length"
									[breadcrumbs]="breadCrumbs()"
									(breadcrumbClick)="breadCrumbRedirect($event)"
								></sh-breadcrumbs>
								<router-outlet></router-outlet>
							</div>
							<div id="sh-secondary-nav-footer-content-div">
								<sh-footer></sh-footer>
							</div>
						</div>
					</sh-secnav-layout-content>
				</sh-secnav-layout>
			}
		</ng-container>
		<ng-container>
			@if (hasAddLicenseAccess()) {
				<router-outlet></router-outlet>
			}
		</ng-container>
	</ng-container>
</ng-container>
